import { BASE_MENU } from '@/service'
import utils from '@/auth/utils'
/** navMenuItems */

export default () => {
    return BASE_MENU.map(item => {
        if (utils.getProfileUserInfo().singedTcDt === null && (item.route === 'password' || item.route === 'otp')) {
            return {
                ...item,
                disabled: true
            }
        }
        return item
    }).sort((a, b) => a.order - b.order)
}
